// extracted by mini-css-extract-plugin
export default {"filter-popup":"styles__filter-popup--2E86g"};